import Helper from "../../Helper";
import { HaulRoute } from "../../models/HaulRoute";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectHaulRoutes(
    team_subdomain: string,
    project_token: string,
    timezone: string
): Promise<HaulRoute[]> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/haul_routes`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((haulRoute: any) => HaulRoute.fromApiObject(haulRoute, timezone));
        })
        .catch((_) => {
            return [];
        });
}

export function getProjectHaulRoute(
    team_subdomain: string,
    project_token: string,
    haul_route_id: number,
    timezone: string
): Promise<HaulRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/haul_routes/${haul_route_id}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return HaulRoute.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function getHaulRouteAttachments(
    team_subdomain: string,
    project_token: string,
    haul_route_id: number
): Promise<any[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/haul_routes/${haul_route_id}/haul_routes_attachments`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .catch((_) => {
            return [];
        });
}

export function createHaulRoute(
    team_subdomain: string,
    project_token: string,
    haulRoute: HaulRoute,
    map_object: MapObject,
    timezone: string
): Promise<HaulRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/haul_routes`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({
                haul_route: haulRoute.toApiObject(),
                map_object: map_object.toApiObject(),
            }),
        },
        true
    )
        .then((data) => {
            return data.json().then((jsonData) => {
                if (!data.ok) {
                    const errorMessage = jsonData.error || data.statusText;
                    throw new Error(errorMessage);
                }
                return jsonData;
            });
        })
        .then((data) => {
            return HaulRoute.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function deleteHaulRoute(team_subdomain: string, project_token: string, haulRoute: HaulRoute): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/haul_routes/${haulRoute.id}`;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function updateHaulRoute(
    team_subdomain: string,
    projectToken: string,
    haulRoute: HaulRoute,
    timezone: string
): Promise<HaulRoute | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${projectToken}/haul_routes/${haulRoute.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ haul_route: haulRoute.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return HaulRoute.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

// Sends only banned_vehicles, so saving the vehicle switches doesn't also save other unsaved edits to the location.
export function updateHaulRouteBannedVehicles(
    team_subdomain: string,
    projectToken: string,
    id: number,
    bannedVehicles: string[]
): Promise<boolean> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${projectToken}/haul_routes/${id}`,
        {
            method: "PUT",
            body: JSON.stringify({ haul_route: { banned_vehicles: bannedVehicles } }),
        }
    )
        .then((response) => response.ok)
        .catch(() => false);
}
